import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout'

Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export const constantRouterMap = [];

export const asyncRouterMap = [];

export default new Router({
  base: '/admin/',
  mode:'history',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      redirect: '/login',
    }, {
      path: '/login',
      name: 'login',
      component: () => import('@/views/account/login.vue')
    }, {
      path: '/home',  // 概览
      redirect: 'home/index',
      component: Layout,
      children: [{
        path: '',
        redirect: 'index',
      }, {
        path: 'index',
        name: 'home_index',
        component: () => import('@/views/home/index.vue'),
      }]
    }, {
      path: '/change_password',  // 修改密码
      redirect: 'change_password',
      component: Layout,
      children: [{
        path: '',
        name: 'change_password',
        component: () => import('@/views/account/changePwd.vue'),
      }]
    },

    {
      path: '/largescreen',   //大屏
      name: 'largescreen',
      component: () => import('@/views/largescreen/index.vue')
    },
    {
      path: '/largescreenV2',   //大屏
      name: 'largescreenV2',
      component: () => import('@/views/largescreen/indexV2.vue')
    },
    {
      path: '/largescreenV2_map',   //大屏
      name: 'largescreenV2_map',
      component: () => import('@/views/largescreen/indexV2_map.vue')
    },
    {
      path: '/regular',   //大屏固定数据
      name: 'regular',
      component: () => import('@/views/largescreen/regular.vue')
    },
    {
      path:'/roles',
      component:Layout,
      children:[{
        path: '',
        redirect: 'roles_index'
      },{
        path: 'roles_index',
        name: 'roles_index',
        component: () => import('@/views/roles/index.vue')
      },{
        path: 'roles_users',
        name: 'roles_users',
        component: () => import('@/views/roles/users.vue')
      }]
    },

    {
      path:'/dailyLog',
      component:Layout,
      children: [{
        path: '',
        redirect: 'index',
      }, {
        path: 'index',
        name: 'dailyLog_index',
        component: () => import('@/views/dailyLog/index.vue'),
      }]
    },
    {
      path:"/basics",
      component:Layout,
      children:[
        {
          path: '',
          redirect:'welcomeSpeech'
        },{
          path: 'welcomeSpeech',
          name:'welcomeSpeech',
          component:()=>import('@/views/basics/welcomeSpeech.vue')
        },{
          path: 'hotline',
          name:'hotline',
          component:()=>import('@/views/basics/hotline.vue')
        },{
          path: 'capacity',
          name:'capacity',
          component:()=>import('@/views/basics/capacity.vue')
        },{
          path: 'parkIntroduction',
          name:'parkIntroduction',
          component:()=>import('@/views/basics/parkIntroduction.vue')
        },{
          path: 'forewarning',
          name:'forewarning',
          component:()=>import('@/views/basics/forewarning.vue')
        },{
          path: 'liveAction',
          name:'liveAction',
          component:()=>import('@/views/publicity/liveAction.vue')
        },{
          path: 'mechanism',
          name:'mechanism',
          component:()=>import('@/views/basics/mechanism.vue')
        }
      ]
    },
	  {
		  path: '/loginFromP13',   //p13登录验证
		  name: 'loginFromP13',
		  component: () => import('@/views/oauth/loginFromP13.vue')
	  },
    {
      path: '/config/page',
      name:'config',
      component:()=>import('@/views/config/index.vue')
    },
    {
      path: '/publicity',
      component: Layout,
      children: [
        {
          path: '/publicity',
          name:'publicity',
          component:()=>import('@/views/publicity/index.vue')
        }
      ]
    },
    {
      path: '/stock',
      component: Layout,
      children: [
        {
          path: '/stock/video_manage',
          name:'video_manage',
          component:()=>import('@/views/stock/list.vue')
        },
        {
          path: '/stock/video_detail',
          name:'video_detail',
          component:()=>import('@/views/stock/detail.vue')
        },
        {
          path: '/stock/compose_list',
          name:'compose_list',
          component:()=>import('@/views/stock/compose_list.vue')
        },
        {
          path: '/stock/course_list_all',
          name:'course_list_all',
          component:()=>import('@/views/stock/course_list_all.vue')
        },
        {
          path: '/stock/video_compose',
          name:'video_compose',
          component:()=>import('@/views/stock/video_compose.vue')
        },
        {
          path: '/stock/video_type',
          name:'video_type',
          component:()=>import('@/views/stock/video_type.vue')
        },
        {
          path: '/stock/banner_list',
          name:'banner_list',
          component:()=>import('@/views/stock/banner_list.vue')
        },
        {
          path: '/stock/edit_conversation',
          name:'edit_conversation',
          component:()=>import('@/views/stock/edit_conversation.vue')
        },
      ]
    },
    {
      path: '/course_list',
      name:'course_list',
      component:()=>import('@/views/course/list.vue')
    },
    {
      path: '/course_play',
      name:'course_play',
      component:()=>import('@/views/course/play.vue')
    },
    {
      path: '/select_role',
      name:'select_role',
      component:()=>import('@/views/account/selectRole.vue')
    },
    {
      path: '/course_calendar',
      name:'course_calendar',
      component:()=>import('@/views/course/calendar.vue')
    },
    {
      path: '/course_my',
      name:'course_my',
      component:()=>import('@/views/course/my.vue')
    },
    {
      path: '/watch_history',
      name:'watch_history',
      component:()=>import('@/views/course/watch_history.vue')
    },
    {
      path: '/conversation',
      name:'conversation',
      component:()=>import('@/views/course/conversation.vue')
    },
    {
      path: '/no_login',
      name:'no_login',
      component:()=>import('@/views/no_login.vue')
    },
    {
      path: '/question2',
      component: Layout,
      children: [
        {
          path: '/question/question_type',
          name:'question_type',
          component:()=>import('@/views/question/question_type.vue')
        },
        {
          path: '/question/question_list',
          name:'question_list',
          component:()=>import('@/views/question/question_list.vue')
        },
        {
          path: '/question/paper_list',
          name:'paper_list',
          component:()=>import('@/views/question/paper_list.vue')
        },
      ]
    },
    {
      path: '/statistics',
      component: Layout,
      children: [
        {
          path: '/statistics/mechanism_statistics',
          name:'mechanism_statistics',
          component:()=>import('@/views/statistics/mechanism_statistics.vue')
        },
        {
          path: '/statistics/student_statistics',
          name:'student_statistics',
          component:()=>import('@/views/statistics/student_statistics.vue')
        },
      ]
    },
    {
			path:'/question',//在线考试
			component:Layout,
			children: [
				{
					path :'topic_class_list',
					name : 'topic_class_list',
					component :()=> import('@/views/topic/TopicClassList.vue')
				},
				{
					path : 'topic_list',
					name:'topic_list',
					component : ()=>import('@/views/topic/TopicList.vue')
				},
				{
					path : 'book_list',
					name : 'book_list',
					component : ()=>import('@/views/topic/BookList.vue')
				},
				{
					path : 'book_list_options',
					name: 'book_list_options',
					component : ()=>import('@/views/topic/BookListOptions.vue')
				},
				{
					path :'exam_list',
					name :'exam_list',
					component : ()=>import('@/views/topic/ExamList.vue')
				},
				{
					path: 'exam_edit',
					name : 'exam_edit',
					component :()=>import('@/views/topic/ExamEdit.vue')
				},
        {
          path: 'certificate_list',
          name : 'certificate_list',
          component :()=>import('@/views/topic/CertificateList.vue')
        },
        {
          path: 'task_list',
          name : 'task_list',
          component :()=>import('@/views/topic/TaskList.vue')
        }
			]
		},
    {
      path: '/virtual_anchor',
      component: Layout,
      children: [
        {
          path: '/virtual_anchor',
          name:'virtual_anchor',
          component:()=>import('@/views/virtual_anchor/virtual_anchor.vue')
        }
      ]
    },
    {
      path: '/chatgpt',
      component: Layout,
      children: [
        {
          path: '/chatgpt',
          name:'chatgpt',
          component:()=>import('@/views/chatgpt/chatgpt.vue')
        }
      ]
    },
    {
      path: '/teacher',
      component: Layout,
      children: [
        {
          path: '/teacher',
          name:'teacher',
          component:()=>import('@/views/teacher/teacher.vue')
        },
        {
          path: '/teacher_detail',
          name:'teacher_detail',
          component:()=>import('@/views/teacher/teacher_detail.vue')
        }
      ]
    },
    {
      path: '/train',
      component: Layout,
      children: [
        {
          path: '/train',
          name:'train',
          component:()=>import('@/views/train/train.vue')
        }
      ]
    },
    {
      path: '/monitor',
      component: Layout,
      children: [
        {
          path: '/monitor',
          name:'monitor',
          component:()=>import('@/views/monitor/monitor.vue')
        }
      ]
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js